import React, { createContext, useState } from "react";

export const UserContext = createContext();
const AuthContext = ({ children }) => {
  const [user, setUsers] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  return (
    <UserContext.Provider value={{ user, setUsers }}>
      {children}
    </UserContext.Provider>
  );
};

export default AuthContext;
